<template>
    <div class="container my-3">
        <div class="row">
            <div class="py-3 col-12 col-md-8 mx-auto alert-light rounded">
                <div class="col-md-12 px-2">
                    <div class="form-group" :class="{'is-invalid': errors.has('Nome')}">
                        <required /> <label>Nome</label>
                        <input v-validate="{required: true}" v-model="dados.request.nome" name="Nome"
                            placeholder="Insira o nome" class="form-control">
                        <div class="invalid-feedback help-block error">{{errors.first('Nome')}}</div>
                    </div>
                </div>
                <div class="col-md-12 px-2">
                    <div class="form-group" :class="{'is-invalid': errors.has('CPF')}">
                        <required /> <label>CPF</label>
                        <input v-validate="{required: true, document: true}" v-model="dados.request.documento"
                            name="CPF" placeholder="Insira o documento" class="form-control"
                            v-mask="['###.###.###-##']">
                        <div class="invalid-feedback help-block error">{{errors.first('CPF')}}</div>
                    </div>
                </div>
                <!-- </div> -->
                <!-- <div class="row"> -->
                <div class="col-md-12 px-2">
                    <div class="form-group" :class="{'is-invalid': errors.has('Email')}">
                        <required /> <label>E-mail</label>
                        <input v-validate="{required: true}" v-model="dados.request.email" disabled name="Email"
                            placeholder="Insira o E-mail" class="form-control">
                        <div class="invalid-feedback help-block error">{{errors.first('Email')}}</div>
                    </div>
                </div>
                <div class="col-md-12 px-2">
                    <div class="form-group" :class="{'is-invalid': errors.has('Telefone')}">
                        <label>Telefone</label>
                        <input v-validate="{required: true}" v-model="dados.request.telefone"
                            placeholder="Insira o numero" name="Telefone" class="form-control"
                            v-mask="['(##) ####-####','(##)# ####-####']">
                        <div class="invalid-feedback help-block error">{{errors.first('Telefone')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['dados'],
        methods: {
            validate() {
                return this.$validator.validateAll().then(valid => {
                    return valid;
                });
            }
        }
    }
</script>

<style scoped src="@/assets/sass/bootstrap4.css"></style>
<style scoped src="@/assets/sass/home.css"></style>
<style scoped lang="scss" src="./register.scss"></style>